import { FocusManager, OnlineManager, Translate } from '../services';
import { EventEmitter } from 'events';
import { TypedEmitter } from '../util';
import { ShowToast } from '../model';

export interface OnlineStateParams {
  readonly onlineManager: OnlineManager;
  readonly focusManager: FocusManager;
  readonly showToast?: ShowToast;
  readonly translate: Translate;
}

export class OnlineState {
  readonly onlineManager;
  readonly focusManager;
  readonly showToast;
  readonly translate;

  readonly events = new EventEmitter() as TypedEmitter<{
    change: (isOnline: boolean) => void;
  }>;

  _removeOfflineToastTimeoutId: ReturnType<typeof setTimeout> | null = null;
  _removeOfflineToast: (() => void) | null = null;

  constructor(params: OnlineStateParams) {
    this.onlineManager = params.onlineManager;
    this.focusManager = params.focusManager;
    this.showToast = params.showToast;
    this.translate = params.translate;
  }

  get isOnline() {
    return this.onlineManager.isOnline();
  }

  showOfflineToast() {
    const { showToast, translate: t } = this;
    if (showToast == null) {
      return;
    }
    this._removeOfflineToast?.();
    this._removeOfflineToast = showToast({
      type: 'ERROR' as any,
      message: t('cairo.offline'),
      biName: 'cairo-offline-error',
      timeout: 'NONE',
    }).remove;

    // this._removeOfflineToastTimeoutId = setTimeout(() => {
    //   this._removeOfflineToastTimeoutId = null;
    //   this._removeOfflineToast?.();
    // }, 6000);
  }

  init() {
    const { focusManager, onlineManager, events } = this;
    const disposers = [
      onlineManager.subscribe(() => {
        const { isOnline } = this;

        events.emit('change', isOnline);

        if (!isOnline) {
          this.showOfflineToast();
        } else {
          this._removeOfflineToast?.();
        }
      }),
      focusManager.subscribe(() => {
        const { isOnline } = this;

        if (focusManager.isFocused() && isOnline && this._removeOfflineToast) {
          this._removeOfflineToast();
        }
      }),
    ];

    return () => {
      disposers.forEach((d) => d());
      if (this._removeOfflineToast) {
        this._removeOfflineToast();
      }

      if (this._removeOfflineToastTimeoutId != null) {
        clearTimeout(this._removeOfflineToastTimeoutId);
      }
    };
  }
}
